import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

const Sponsor = ({ sponsor }) => {
    return (
        <ScrollAnimation animateIn="fadeInLeftBig" animateOnce={true} className="d-flex justify-content-center w-100">
            {sponsor.Logo && (
                <div className="align-self-center d-flex flex-row justify-content-center sponsor" style={{ height: 100 }}>
                    <img alt="" src={sponsor.Logo} className="align-self-center" style={{ maxHeight: 100 }} />
                </div>)}
        </ScrollAnimation>
    );
}

export default Sponsor;



// WEBPACK FOOTER //
// ./src/components/sponsors/partials/sponsor.js